// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || '/api/v1';

// App Configuration
export const APP_NAME = 'Marlin Trades';
export const APP_VERSION = '1.0.0';

// Feature Flags
export const FEATURES = {
  SSE_ENABLED: true,
  REAL_TIME_UPDATES: true,
  TICKER_MANAGEMENT: true,
  SCHWAB_INTEGRATION: true,
};

// Pagination Defaults
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 50,
  MAX_PAGE_SIZE: 100,
  PAGE_SIZE_OPTIONS: [10, 25, 50, 100],
};

// Date Formats
export const DATE_FORMATS = {
  DISPLAY: 'MMM dd, yyyy',
  API: 'yyyy-MM-dd',
  DATETIME: 'MMM dd, yyyy HH:mm:ss',
  TIME: 'HH:mm:ss',
};

// Currency Configuration
export const CURRENCY = {
  DEFAULT: 'USD',
  SYMBOL: '$',
  DECIMAL_PLACES: 2,
};

// Number Formatting
export const NUMBER_FORMATS = {
  DECIMAL_PLACES: 2,
  THOUSANDS_SEPARATOR: ',',
  DECIMAL_SEPARATOR: '.',
};

// Local Storage Keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'token',
  USER_PREFERENCES: 'userPreferences',
  THEME: 'theme',
  LANGUAGE: 'language',
};

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network error. Please check your connection.',
  UNAUTHORIZED: 'You are not authorized to perform this action.',
  FORBIDDEN: 'Access denied.',
  NOT_FOUND: 'The requested resource was not found.',
  SERVER_ERROR: 'An internal server error occurred.',
  VALIDATION_ERROR: 'Please check your input and try again.',
  TIMEOUT: 'Request timed out. Please try again.',
};

// Success Messages
export const SUCCESS_MESSAGES = {
  SAVED: 'Changes saved successfully.',
  CREATED: 'Item created successfully.',
  UPDATED: 'Item updated successfully.',
  DELETED: 'Item deleted successfully.',
  LOGGED_IN: 'Successfully logged in.',
  LOGGED_OUT: 'Successfully logged out.',
};

// Validation Rules
export const VALIDATION = {
  PASSWORD_MIN_LENGTH: 8,
  PASSWORD_MAX_LENGTH: 128,
  EMAIL_MAX_LENGTH: 254,
  NAME_MAX_LENGTH: 100,
  SYMBOL_MAX_LENGTH: 20,
  DESCRIPTION_MAX_LENGTH: 500,
};

// Timeouts
export const TIMEOUTS = {
  API_REQUEST: 30000, // 30 seconds
  SSE_RECONNECT: 5000, // 5 seconds
  DEBOUNCE: 300, // 300ms
  TOAST: 5000, // 5 seconds
};

// Colors (for charts and UI)
export const COLORS = {
  PRIMARY: '#3B82F6',
  SECONDARY: '#6B7280',
  SUCCESS: '#10B981',
  WARNING: '#F59E0B',
  ERROR: '#EF4444',
  INFO: '#06B6D4',
  LIGHT: '#F9FAFB',
  DARK: '#111827',
};

// Chart Configuration
export const CHART_CONFIG = {
  COLORS: [
    '#3B82F6',
    '#10B981',
    '#F59E0B',
    '#EF4444',
    '#8B5CF6',
    '#06B6D4',
    '#F97316',
    '#84CC16',
  ],
  ANIMATION_DURATION: 750,
  RESPONSIVE: true,
  MAINTAIN_ASPECT_RATIO: false,
};

const config = {
  API_BASE_URL,
  APP_NAME,
  APP_VERSION,
  FEATURES,
  PAGINATION,
  DATE_FORMATS,
  CURRENCY,
  NUMBER_FORMATS,
  STORAGE_KEYS,
  ERROR_MESSAGES,
  SUCCESS_MESSAGES,
  VALIDATION,
  TIMEOUTS,
  COLORS,
  CHART_CONFIG,
};

export default config;
